import React, { memo } from 'react';

import { Typography } from '@mui/material';
import { ClockIcon } from 'app/shared/componentsRestyled/coreDesignSystem/icons';
import LabelCDS from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS';
import { LabelVariant } from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS/LabelCDS.constants';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';
import useElapsedTime from 'hooks/useElapsedTime';

const ElapsedTimeLabel = ({ startTime }) => {
  const elapsedText = useElapsedTime(startTime);

  return (
    <LabelCDS
      title={
        <>
          <ClockIcon size={IconSize[16]} />
          <Typography variant="regular12">{elapsedText}</Typography>
        </>
      }
      variant={LabelVariant.BLUE}
    />
  );
};

ElapsedTimeLabel.propTypes = {
  startTime: PropTypes.string.isRequired,
};

export default memo(ElapsedTimeLabel);
